<template>
  <div>
    <button
      type="button"
      @click.stop="onEditClicked"
      class="btn btn-sm btn-webon-table"
    >
      <i class="fa fa-eye" />
    </button>
  </div>
</template>

<script>

export default {
  name: "row-kardex-record-actions",
  props: {
    data: { type: Object },
  },
  methods: {
    onEditClicked() {
        console.log("Ejecutar servicio");
    }
  }
};
</script>